// extracted by mini-css-extract-plugin
export default {"badge":"_2L1a6","small":"_3TUnJ","medium":"_3-O4c","large":"_1aZ0P","primary":"_2_knP","secondary":"_1ou8f"};